import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0d99f20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex newsBox" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "d-flex flex-column ps-2" }
const _hoisted_5 = ["href", "title"]
const _hoisted_6 = { class: "d-flex newsBox" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "d-flex flex-column ps-2" }
const _hoisted_10 = ["href", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "newsDropDownRef",
    class: _normalizeClass('menu menu-sub menu-sub-dropdown ' + (_ctx.isMobile ? 'mt-2 ' : 'me-2 '))
  }, [
    _createVNode(_component_el_tabs, {
      type: "border-card",
      stretch: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: _ctx.isEN ? 'News' : 'Tin tức'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass('px-5 py-5  overflow-scroll ' + (_ctx.isMobile ? 'mh-400px' : 'mh-450px'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "mb-5"
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("a", {
                      href: item.url,
                      target: "_blank",
                      class: "w-100 h-100 border-0"
                    }, [
                      _createElementVNode("img", {
                        class: "newsImage rounded",
                        src: item.featured_image_url ? item.featured_image_url : 'img/default-image.jpg'
                      }, null, 8, _hoisted_3)
                    ], 8, _hoisted_2),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("a", {
                        class: _normalizeClass('form-label fw-bolder text-start text-primary bg-transparent ' + (_ctx.isMobile ? ' fs-5' : ' fs-4')),
                        href: item.link,
                        target: "_blank",
                        title: _ctx.isEN ? item.enTitle ? item.enTitle : item.title_raw : item.title_raw
                      }, _toDisplayString(_ctx.isEN ? item.enTitle ? item.enTitle : item.title_raw : item.title_raw), 11, _hoisted_5),
                      _createElementVNode("div", {
                        class: _normalizeClass('fs-5 shortContent' + (_ctx.isMobile ? ' fs-6' : ' fs-5'))
                      }, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.isEN ? item.enShortContent ? item.enShortContent : item.excerpt_raw :
                                        item.excerpt_raw), 1)
                      ], 2)
                    ])
                  ])
                ]))
              }), 128))
            ], 2)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_tab_pane, {
          label: _ctx.isEN ? 'Events' : 'Sự kiện'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass('px-5 py-5   overflow-scroll ' + (_ctx.isMobile ? 'mh-400px' : 'mh-450px'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventsList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "pb-5"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("a", {
                      href: item.url,
                      target: "_blank",
                      class: "w-100 h-100 border-0"
                    }, [
                      _createElementVNode("img", {
                        class: "newsImage rounded",
                        src: item.featured_image_url ? item.featured_image_url : 'img/default-image.jpg'
                      }, null, 8, _hoisted_8)
                    ], 8, _hoisted_7),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("a", {
                        class: _normalizeClass('form-label fw-bolder text-start text-primary bg-transparent ' + (_ctx.isMobile ? ' fs-5' : ' fs-4')),
                        href: item.url,
                        target: "_blank",
                        title: _ctx.isEN ? item.enTitle ? item.enTitle : item.title_raw : item.title_raw
                      }, _toDisplayString(_ctx.isEN ? item.enTitle ? item.enTitle : item.title_raw : item.title_raw), 11, _hoisted_10),
                      _createElementVNode("div", {
                        class: _normalizeClass('fs-5 shortContent' + (_ctx.isMobile ? ' fs-6' : ' fs-5'))
                      }, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.isEN ? item.enShortContent ? item.enShortContent : item.excerpt_raw :
                                        item.excerpt_raw), 1)
                      ], 2)
                    ])
                  ])
                ]))
              }), 128))
            ], 2)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    })
  ], 2))
}